/*
 * @format
 */

export const LOGOUT_STARTED = 'Logout';
export const LOGOUT_COMPLETED = 'Logout Completed';
export const LOGOUT_FAILED = 'Logout Failed';

export const AMPLIFY_STATE_CHANGE = 'Amplify State Change';
export const SIGNUP = 'Sign up form submitted';
export const SIGNUP_SENSITIVE = 'Sign up form sensitive info';

export const SIGNUP_STARTED = 'Signup Started';
export const SIGNUP_COMPLETE = 'Signup Completed';
export const SIGNUP_FAILED = 'Signup Failed';

export const ACCEPT_TERMS_SET = 'Accept Terms & Conditions set';
export const ACCEPT_TERMS_CLEARED = 'Accept Terms & Conditions cleared';
export const ACCEPT_MARKETING_SET = 'Accept Marketing set';

export const DARWIN_REGISTRATION_REQUIRED = 'Darwin registration required';
export const DARWIN_REGISTRATION_STARTED = 'Darwin registration started';
export const DARWIN_REGISTRATION_FAILED = 'Darwin registration failed';
export const DARWIN_REGISTRATION_COMPLETED = 'Darwin registration completed';

export const DEVICE_REGISTRATION_SERIALNUMBER_SET =
  'Device registration serial number added';
export const DEVICE_REGISTRATION_ATTEMPTS_RESET =
  'Device registration failed attempts reset';

export const LIST_ALL_DEVICES_STARTED = 'List All Devices Started';
export const LIST_ALL_DEVICES_FAILED = 'List All Devices Failed';
export const LIST_ALL_DEVICES_SUCCEEDED = 'List All Devices Complete';

export const WEBSOCKET_HELLO_MESSAGE_RECEIVED = 'Received Hello Message';
export const WEBSOCKET_HELLO_MESSAGE_TIMEOUT = 'Hello message timed out';
export const WEBSOCKET_HELLO_MESSAGE_TIMEOUT_CLEARED =
  'Hello message timeout cleared';
export const WEBSOCKET_SET_PRT_MODE_RECEIVED = 'Set PRT Mode Message Received ';
export const WEBSOCKET_SET_PRT_MODE_REJECTED = 'Set PRT Mode Message Rejected';

export const WEBSOCKET_PUBLISH_STARTED = 'Get Publish Started';
export const WEBSOCKET_PUBLISH_REJECTED = 'Get Publish Rejected';
export const WEBSOCKET_PUBLISH_RECEIVED = 'Get Publish Received';

export const WEBSOCKET_LIVE_RECEIVED = 'Received Live Message';
export const WEBSOCKET_PRT_LIVE_RECEIVED = 'Received PRT Live Message';

export const WEBSOCKET_LIVE_DATA_RECEIVED = 'Received Live Data Message';

export const WEBSOCKET_DESIRED_STATE_RECEIVED = 'Received Desired State Message';

// A GC signal for the settling overlay: drop the named settling entries from an
// interface once this phone's own reported telemetry has confirmed them (or a
// TTL backstop has elapsed). Dispatched by the desired-state-settling saga; the
// reducer holds the slice, which is deliberately isolated from reported state,
// so the reported-match decision is made in the saga and only the ids to remove
// cross the boundary.
export const DESIRED_STATE_SETTLING_PRUNED = 'Desired State Settling Pruned';

export const WEBSOCKET_SET_OVERRIDE_RECEIVED = 'Received Set Override Message';
export const WEBSOCKET_SET_OVERRIDE_REJECTED = 'Rejected Set Override Message';
export const WEBSOCKET_CANCEL_OVERRIDE_RECEIVED =
  'Received Clear Override Message';
export const WEBSOCKET_CANCEL_OVERRIDE_REJECTED =
  'Rejected Clear Override Message';
export const WEBSOCKET_MESSAGE_RECEIVED = 'Received websocket message';
export const WEBSOCKET_OPENED = 'Websocket Opened';
export const WEBSOCKET_CLOSED = 'Websocket Closed';

export const PENDING_CHANGE_TIMED_OUT = 'Pending change timed out';
export const PENDING_CHANGE_SUPERSEDED = 'Pending change superseded';
export const PENDING_CHANGE_FAILED = 'Pending change failed';

export const SET_MODE_STARTED = 'Set Mode Started';
export const SET_MODE_SEND = 'Set Mode Send';

export const ADD_MODE_ERROR = 'Add Mode Error';
export const REMOVE_MODE_ERROR = 'Remove Mode Error';

export const PLUS_HOURS_SELECTED = 'Plus Hours Selected';
export const PLUS_HOURS_CONFIRMED = 'Plus Hours Confirmed';
export const PLUS_HOURS_CANCELLED = 'Plus Hours Cancelled';
export const PLUS_HOURS_DISMISSED = 'Plus Hours Dismissed';

export const SET_SETPOINT_STARTED = 'Set Setpoint Started';
export const SET_SETPOINT_SEND = 'Set Setpoint Send';

export const WEBSOCKET_SET_SETPOINT_RECEIVED = 'Received Set Setpoint Message';
export const WEBSOCKET_SET_SETPOINT_REJECTED = 'Rejected Set Setpoint Message';

export const OVERRIDE_DISMISSED = 'Override Dismissed';

export const CLEAR_OVERRIDE_COMMANDS = 'Clear Override Commands';

export const DISMISS_ERROR = 'Dismiss error';

export const SET_HOLIDAY_SEND = 'Set Holiday Send';
export const SET_HOLIDAY_MODE_STARTED = 'Set Holiday Mode Started';
export const SET_HOLIDAY_CONFIRMATION_PENDING = 'Set Holiday Mode Pending';
export const SET_HOLIDAY_CONFIRMATION_FAILED =
  'Set Holiday Confirmation Failed';
export const SET_HOLIDAY_CONFIRMATION_CLEAR = 'Set Holiday Confirmation Clear';
export const WEBSOCKET_SET_HOLIDAY_MODE_REJECTED = 'Set Holiday Mode Rejected';
export const WEBSOCKET_SET_HOLIDAY_MODE_RECEIVED = 'Set Holiday Mode Received';

export const CANCEL_HOLIDAY_SEND = 'Cancel Holiday Send';

export const COMMAND_SENT = 'Command sent';
export const COMMAND_COMPLETED = 'Command completed';
export const CLEAR_LAST_COMPLETED_COMMAND = 'Clear Last Completed Command';

export const SI_REGISTRATION_RESET = 'SI Registration Reset';
export const SI_REGISTRATION_STARTED = 'SI Registration Started';
export const SI_REGISTRATION_COMPLETION_STARTED =
  'SI Registration Completion Started';
export const SI_REGISTRATION_COMPLETION_TIMEOUT =
  'SI Registration Completion Timeout';

export const REMOVE_HOME = 'Remove Home';

export const PRT_COPY_SETTING_STARTED = 'PRT Settings Copy Started';
export const PRT_SETTINGS_UPDATE_STARTED = 'PRT Settings Update Started';
export const PRT_SETTINGS_UPDATE_TIMED_OUT = 'PRT Settings Update Timed out';
export const WEBSOCKET_PRT_SETTINGS_UPDATE_REJECTED =
  'PRT Settings Update Rejected';
export const WEBSOCKET_PRT_SETTINGS_UPDATE_RECEIVED =
  'PRT Settings Update Received';

export const NOTIFICATION_RECEIVED = 'Notification Received';
export const NOTIFICATION_TOKEN_UPDATED = 'Notificaton Token Updated';

export const CUSTOM_PROPERTIES_UPDATE_STARTED =
  'Custom Properties Update Started';
export const CUSTOM_PROPERTIES_UPDATE_COMPLETED = 'Custom Properties Updated';
export const CUSTOM_PROPERTIES_UPDATE_TIMEOUT =
  'Custom Properties Update Timeout';
export const CUSTOM_PROPERTIES_UPDATE_RESET = 'Custom Properties Update Reset';

export const SEND_PRT_STATE_CHANGE = 'SEND_PRT_STATE_CHANGE';

export const SEND_CONTROL = 'SEND_CONTROL';
export const DEBOUNCED_SEND_CONTROL = 'Super debounce - Queue message';
export const CLEAR_TO_SEND = 'Super debounce - Clear to send';
export const RESET_QUEUE = 'Super debounce - Reset Queue';
export const NO_SENDS_IN_PROGRESS = 'Super debounce - No sends in progress';
export const CLEAR_PENDING_STATE = 'Super debounce - Clear pending state';

// Demo mode only: toggles the header "updating" (wave) indicator without
// going through the send-control saga.
export const DEMO_CHANGE_TRACKER = 'Demo - change tracker';

// Demo mode only: mirrors the AuthenticationContext demo flag into redux so
// thunks (e.g. PRT setting requests) can branch on it.
export const SET_DEMO_MODE = 'Demo - set mode';

// Demo mode only: visibility of the global "not available in demo mode"
// modal, driven through redux so thunks and screens share one mechanism.
export const DEMO_UNAVAILABLE_SHOWN = 'Demo - unavailable shown';
export const DEMO_UNAVAILABLE_DISMISSED = 'Demo - unavailable dismissed';

// Demo mode only: commits confirmed values onto the reported zone state (what
// a live message would normally do), so selectors that read reported data
// (e.g. the heating flame indicator) stay in sync with demo changes.
export const DEMO_ZONE_REPORTED = 'Demo - zone reported';

export const RESUME_REGISTRATION_START = 'Resume registration - start';
export const RESUME_REGISTRATION_RETURN_TO_APP =
  'Resume registration - return to app';
export const RESUME_REGISTRATION_COMPLETE = 'Resume registration - complete';
export const RESUME_REGISTRATION_ABORT = 'Resume registration - abort';

export const HOMES_MESSAGE_RECEIVED = 'Received Homes Message';
export const UPDATE_HOME_PROPERTY = 'Update Home Property';

export const GEOLOCATION_DEVICE_ADDED = 'Geolocation Device Added';
export const GEOLOCATION_DEVICE_REMOVED = 'Geolocation Device Removed';
export const GEOLOCATION_DEVICE_UPDATED = 'Geolocation Device Updated';

export const SET_ZONES_PENDING = 'Zones Pending Set';
export const CLEAR_ZONES_PENDING = 'Zones Pending Cleared';

export const GEOLOCATION_LOCATION_CONFIRMATION_PENDING =
  'Geolocation Device Confirmation Pending';
export const GEOLOCATION_LOCATION_CONFIRMATION_FAILED =
  'Geolocation Device Confirmation Failed';
export const GEOLOCATION_LOCATION_CONFIRMATION_CLEAR =
  'Geolocation Device Confirmation Clear';

export const SI_SETTINGS_UPDATE = 'Si Settings Update';
export const WEBSOCKET_SI_SETTINGS_UPDATE_REJECTED =
  'SI Settings Update Rejected';
export const WEBSOCKET_SI_SETTINGS_UPDATE_RECEIVED =
  'SI Settings Update Received';

export const INTERFACE_SETTINGS_UPDATE_STARTED =
  'Interface Settings Update Started';
export const INTERFACE_SETTINGS_UPDATE_TIMED_OUT =
  'Interface Settings Update Timed out';
export const WEBSOCKET_INTERFACE_SETTINGS_UPDATE_REJECTED =
  'Interface Settings Update Rejected';
export const WEBSOCKET_INTERFACE_SETTINGS_UPDATE_RECEIVED =
  'Interface Settings Update Received';

export const SET_SCHEDULE_STARTED = 'Schedule Started';
export const SET_SCHEDULE_CONFIRMED = 'Schedule Confirmed';
export const SET_SCHEDULE_REJECTED = 'Schedule Rejected';
export const SET_SCHEDULE_TIMED_OUT = 'Schedule Timeout';
export const CLEAR_SET_SCHEDULE_REQUEST = 'Schedule request cleared';
export const CLEAR_PENDING_SCHEDULE = 'Schedule Clear Pending state';

export const SET_SCHEDULES_BATCH_STARTED = 'Schedules Batch Started';
export const SET_SCHEDULES_BATCH_CONFIRMED = 'Schedules Batch Confirmed';
export const SET_SCHEDULES_BATCH_REJECTED = 'Schedules Batch Rejected';
export const SET_SCHEDULES_BATCH_TIMED_OUT = 'Schedules Batch Timeout';
export const CLEAR_SET_SCHEDULES_BATCH_REQUEST =
  'Schedules batch request cleared';

// Draft schedule action types (local changes before API submission)
export const SET_DRAFT_SCHEDULE = 'Draft Schedule Set';
export const CLEAR_DRAFT_SCHEDULE = 'Draft Schedule Clear';
export const CLEAR_ALL_DRAFT_SCHEDULES = 'Draft Schedules Clear All';

export const WEATHER_OPTIMISATION_STARTED = 'Weather Optimisation Started';
export const WEATHER_OPTIMISATION_TIMEOUT = 'Weather Optimisation Timeout';
export const WEATHER_OPTIMISATION_COMPLETED = 'Weather Optimisation Completed';
export const WEATHER_OPTIMISATION_RESET = 'Weather Optimisation reset';

export const SET_ZONE_NAME_STARTED = 'Set Zone Name Started';
export const SET_ZONE_NAME_TIMEOUT = 'Set Zone Name Timeout';
export const SET_ZONE_NAME_RECEIVED = 'Set Zone Name Received';
export const SET_ZONE_NAME_REJECTED = 'Set Zone Name Rejected';
export const CLEAR_ZONE_NAME_REQUEST_STATUS = 'Clear Zone Name Request Status';

export const SET_HEAT_TYPE = 'Set Heat Type';

export const CLEAR_LIVE_DATA = 'Clear Live Data';

export const COMMAND_STATUS_ACK = 'Command Acknowledged';
export const COMMAND_STATUS_NACK = 'Command Rejected';
export const DEVICE_SERVICE_REQUEST_STARTED = 'Device Service Command Started';

export const DISABLE_DSR = 'User Disabled DSR';
export const ENABLE_DSR = 'Enable DSR';
export const FETCH_PENDING_DSR_COMMANDS = 'Fetch Pending DSR Commands';
export const PENDING_DSR_COMMANDS_RECEIVED = 'Pending DSR Commands Received';
export const REMOVE_PENDING_DSR_COMMANDS = 'Delete Pending DSR Commands';

export const SET_DSR_STATUS_SEND = 'Set DSR Status Send';
export const SET_DSR_STATUS_STARTED = 'Set DSR Status Started';
export const WEBSOCKET_SET_DSR_STATUS_RECEIVED = 'Set DSR Status Confirmed';
export const WEBSOCKET_SET_DSR_STATUS_REJECTED = 'Set DSR Rejected';

export const DSR_AUTO_ACCEPT_UPDATE = 'Update DSR Auto Accept';

export const PARTNER_ACCESS_REQUESTS_CREATED =
  'Partner Access Requests Created';
export const PARTNER_ACCESS_REQUESTS_RECEIVED =
  'Partner Access Requests Received';
export const PARTNER_ACCESS_REQUESTS_REMOVE = 'Partner Access Requests Remove';

export const HALO_NOTIFICATION_MESSAGES_INIT = 'Halo Notification Messages Init';
export const HALO_NOTIFICATION_MESSAGES_FETCH = 'Halo Notification Messages Fetch';
export const HALO_NOTIFICATION_MESSAGES_RECEIVED = 'Halo Notification Messages Received';
export const HALO_NOTIFICATION_MESSAGES_UNREAD_COUNT_RECEIVED = 'Halo Notification Messages Unread Count Received';
export const HALO_NOTIFICATION_MESSAGE_MARK_READ = 'Halo Notification Message Mark Read';
export const HALO_NOTIFICATION_MESSAGE_HIDE = 'Halo Notification Message Hide';
